<div class="card">
    <app-header titulo="Serviços" descricao="Dados de integração de serviços"></app-header>
  
    <p-table [value]="servicos" dataKey="idPagto" [loading]="processando" #dt [globalFilterFields]="['instancia','cdProcesso','cdItemErp','cdFornecPims','cdFornecErp','cdCcustoErp','cdContratoPims','cdAprovErp', 'cdFavorecErp', 'noDocErp', 'deMensagemInteg', 'cdMunicIbge']" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines" [rowsPerPageOptions]="[20, 50, 100]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true" currentPageReportTemplate="{{servicosSelecionados.length}} Registros selecionados | Mostrando de {first} até {last} de {totalRecords} registros" [(selection)]="servicosSelecionados">
        <ng-template pTemplate="caption">
            <div class="flex">

              <p-multiSelect
                   appendTo="body"
                   [options]="processos"
                   [filter]="true"
                   [style]="{'width':'300px'}"
                   optionLabel="nome"
                   [(ngModel)]="processosSelecionados"
                   placeholder="Processo"
                    emptyMessage="Nenhum processo disponivel"
                    (onChange)="getServicos()">
                     <ng-template let-value pTemplate="selectedItems">
                        <div class="inline-flex align-items-center gap-2 px-1" *ngFor="let option of value">
                            
                            <div>{{ option.instancia }}-Pagto: {{ option.dtPagto | date: 'dd/MM/yyyy' }}</div>
                        </div>
                        <div *ngIf="!value || value.length === 0">Selecione um processo</div>
                    </ng-template>
                    <ng-template let-processo pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <div [ngStyle]="{ color: processo.exportado ? 'gray' : null }">{{ processo.instancia }}-{{ processo.deProcesso}} | Período: {{ processo.dtIniSint | date: 'dd/MM/yyyy'}}-{{ processo.dtFimSint | date: 'dd/MM/yyyy'}} | Pagto: {{ processo.dtPagto | date: 'dd/MM/yyyy' }}</div>
                        </div>
                    </ng-template>
              </p-multiSelect>

                <div class="flex justify-content-center">
                </div>
                <div class="flex justify-content-center">
                  <button class="ml-3" pButton (click)="sincronizar()" style="font-size: 1.0rem" [loading]="loadingSincronizar" [disabled]="processando" icon="pi pi-arrow-down-right" label="Buscar PIMS"></button>
                  <button class="ml-3" pButton (click)="integrar()" style="font-size: 1.0rem" [loading]="loadingIntegrar" [disabled]="processando" icon="pi pi-arrow-up-right" label="Enviar ERP"></button>
                  <button class="ml-3" pButton (click)="exportar()" style="font-size: 1.0rem" [loading]="loadingIntegrar" [disabled]="processando" icon="pi pi-file-excel" label="Exportar"></button>
                  <p-splitButton class="ml-3" label="Reversão" icon="pi pi-undo" [model]="itensReversao" />
                </div>
                  <!-- <input  class="ml-8" [style]="{'width':'140px'}" pInputText type="text" [(ngModel)]="processo" placeholder="Código processo"> -->
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')" placeholder="Pesquisar" />
                </span>
                <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="getServicos()" [loading]="processando"></button>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
              <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
              <th>Id Pagto.</th>
              <th>Instância</th>
              <th>Código Processo</th>
              <th>Data Recebido</th>
              <th>Data Pagamento</th>
              <th>Código Item ERP</th>
              <th>Quantidade item</th>
              <th>Código Fornec. PIMS</th>
              <th>Código Fornec. ERP</th>
              <th>Código Municipio IBGE</th>
              <th>Valor Total</th>
              <th>Valor Desconto</th>
              <th>Valor Líquido</th>
              <th>CCusto ERP</th>
              <th>Código Contrato PIMS</th>
              <th>Código Aprovação ERP</th>
              <th>Código Favorec. ERP</th>
              <th>Quantide Perc. Favorec</th>
              <th>Valor Líquido Favorec</th>
              <th>Valor Bruto Favorec</th>
              <th pSortableColumn="fgStatusInteg">Status <p-sortIcon field="fgStatusInteg" /></th>
              <th>Data Integ ERP</th>
              <th>Mensagem</th>
              <th>Documento ERP</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-servico>
            <tr>
              <td><p-tableCheckbox [value]="servico" /></td>
              <td>{{ servico.idPagto }}</td>
              <td>{{ servico.instancia }}</td>
              <td>{{ servico.cdProcesso }}</td>
              <td>{{ servico.dtRecebido }}</td>
              <td>{{ servico.dtPagto }}</td>
              <td>{{ servico.cdItemErp }}</td>
              <td>{{ servico.qtItem }}</td>
              <td>{{ servico.cdFornecPims }}</td>
              <td>{{ servico.cdFornecErp }}</td>
              <td>{{ servico.cdMunicIbge }}</td>
              <td>{{ servico.vlTotal.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
              <td>{{ servico.vlDesconto.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
              <td>{{ servico.vlLiquido.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2})  || 0 }}</td>
              <td>{{ servico.cdCcustoErp }}</td>
              <td>{{ servico.cdContratoPims }}</td>
              <td>{{ servico.cdAprovErp }}</td>
              <td>{{ servico.cdFavorecErp }}</td>
              <td>{{ servico.qtPercFavorec }}</td>
              <td>{{ servico.vlLiquidoFavorec }}</td>
              <td>{{ servico.vlBrutoFavorec }}</td>
              <td><app-tag-status [status]="servico.fgStatusInteg" ></app-tag-status> </td>
              <td>{{ servico.dtIntegErp }}</td>
              <td>{{ servico.deMensagemInteg }}</td>
              <td>{{ servico.noDocErp }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <td colspan="10">Nenhum registro encontrado</td>
        </ng-template>
    </p-table>

    <p-confirmDialog header="Confirmation" width="425"></p-confirmDialog>
  </div>
  